/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountReportDto } from '../models/AccountReportDto';
import type { AccountReportTypes } from '../models/AccountReportTypes';
import type { GenerateReportInput } from '../models/GenerateReportInput';
import type { ReportResultDto } from '../models/ReportResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReportService {

    /**
     * @param version 
     * @returns AccountReportDto OK
     * @throws ApiError
     */
    public static getReports(
version: string,
): CancelablePromise<Array<AccountReportDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Report',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param type 
     * @param version 
     * @param requestBody 
     * @returns ReportResultDto OK
     * @throws ApiError
     */
    public static generateReport(
type: AccountReportTypes,
version: string,
requestBody?: GenerateReportInput,
): CancelablePromise<ReportResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Report/{type}',
            path: {
                'type': type,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
